import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FilterChip } from '~/components/AiSearchChips/FilterChip/FilterChip';
import { useLocaleKeys } from '~/i18n';
import { useSettingsChipTone } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/settingsChipTone';
import { summarizeServicePredicate } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/summarizeServicePredicate';
import { serviceAlternatives } from '../serviceConditionDisplay';
import { operatorLabel } from './ServiceConditionChip.utils';
export const ServiceConditionChip = (param)=>{
    let { testId, quantifier, predicate, onToggleQuantifier, onRemove } = param;
    var _ref, _ref1;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const tone = useSettingsChipTone();
    const alternatives = serviceAlternatives(predicate, t);
    const useSegments = alternatives != null && alternatives.labels.length > 1;
    const valueSegments = useSegments ? alternatives.labels.map((label)=>({
            label
        })) : undefined;
    return /*#__PURE__*/ _jsx(FilterChip, {
        testId: testId,
        fieldLabel: t.servicesLabel(),
        operator: {
            label: operatorLabel(quantifier, (_ref = alternatives === null || alternatives === void 0 ? void 0 : alternatives.isHas) !== null && _ref !== void 0 ? _ref : false, t),
            onToggle: onToggleQuantifier,
            biName: 'drafts_ai_search_chip_toggle_services_quantifier'
        },
        valueSegments: valueSegments,
        combinator: useSegments ? t.orConnector() : undefined,
        valueLabel: useSegments ? undefined : (_ref1 = alternatives === null || alternatives === void 0 ? void 0 : alternatives.labels[0]) !== null && _ref1 !== void 0 ? _ref1 : summarizeServicePredicate(predicate, t),
        onRemove: onRemove,
        removeBiName: "drafts_ai_search_chip_remove_services",
        tone: tone
    });
};
